import UpcomingTripsSummaryContainer from './UpcomingTripsSummaryContainer';

export default UpcomingTripsSummaryContainer;
